/**
 * Application error codes and messages.
 * Used for typed error handling across packages.
 */
export const ERROR_CODES = {
    // Auth errors
    AUTH_UNAUTHORIZED: 'AUTH_UNAUTHORIZED',
    AUTH_FORBIDDEN: 'AUTH_FORBIDDEN',
    AUTH_SESSION_EXPIRED: 'AUTH_SESSION_EXPIRED',
    AUTH_INVALID_TOKEN: 'AUTH_INVALID_TOKEN',
    // Validation errors
    VALIDATION_FAILED: 'VALIDATION_FAILED',
    INVALID_DATE_RANGE: 'INVALID_DATE_RANGE',
    INVALID_EMPLOYEE_ID: 'INVALID_EMPLOYEE_ID',
    INVALID_REPORT_FORMAT: 'INVALID_REPORT_FORMAT',
    // Resource errors
    EMPLOYEE_NOT_FOUND: 'EMPLOYEE_NOT_FOUND',
    REPORT_NOT_FOUND: 'REPORT_NOT_FOUND',
    VERIFICATION_NOT_FOUND: 'VERIFICATION_NOT_FOUND',
    SETTINGS_NOT_FOUND: 'SETTINGS_NOT_FOUND',
    // External service errors
    GITHUB_API_ERROR: 'GITHUB_API_ERROR',
    JIRA_API_ERROR: 'JIRA_API_ERROR',
    SLACK_API_ERROR: 'SLACK_API_ERROR',
    JOBKAN_API_ERROR: 'JOBKAN_API_ERROR',
    LLM_API_ERROR: 'LLM_API_ERROR',
    // Collection pipeline errors
    COLLECTION_ALREADY_RUNNING: 'COLLECTION_ALREADY_RUNNING',
    EXECUTION_NOT_FOUND: 'EXECUTION_NOT_FOUND',
    EVIDENCE_STORAGE_ERROR: 'EVIDENCE_STORAGE_ERROR',
    COLLECTION_SOURCE_UNAVAILABLE: 'COLLECTION_SOURCE_UNAVAILABLE',
    // Notification errors
    NOTIFICATION_SEND_FAILED: 'NOTIFICATION_SEND_FAILED',
    NOTIFICATION_DUPLICATE: 'NOTIFICATION_DUPLICATE',
    COMPLIANCE_CALC_FAILED: 'COMPLIANCE_CALC_FAILED',
    // Verification errors
    VERIFICATION_ALREADY_EXISTS: 'VERIFICATION_ALREADY_EXISTS',
    // Rate limiting
    RATE_LIMIT_EXCEEDED: 'RATE_LIMIT_EXCEEDED',
    // System errors
    INTERNAL_ERROR: 'INTERNAL_ERROR',
    SERVICE_UNAVAILABLE: 'SERVICE_UNAVAILABLE',
    DATABASE_ERROR: 'DATABASE_ERROR',
};
export const ERROR_MESSAGES = {
    [ERROR_CODES.AUTH_UNAUTHORIZED]: 'Authentication required',
    [ERROR_CODES.AUTH_FORBIDDEN]: 'Insufficient permissions',
    [ERROR_CODES.AUTH_SESSION_EXPIRED]: 'Session has expired, please log in again',
    [ERROR_CODES.AUTH_INVALID_TOKEN]: 'Invalid authentication token',
    [ERROR_CODES.VALIDATION_FAILED]: 'Request validation failed',
    [ERROR_CODES.INVALID_DATE_RANGE]: 'Invalid date range provided',
    [ERROR_CODES.INVALID_EMPLOYEE_ID]: 'Invalid employee ID format',
    [ERROR_CODES.INVALID_REPORT_FORMAT]: 'Report does not match expected format',
    [ERROR_CODES.EMPLOYEE_NOT_FOUND]: 'Employee not found',
    [ERROR_CODES.REPORT_NOT_FOUND]: 'Report not found',
    [ERROR_CODES.VERIFICATION_NOT_FOUND]: 'Verification not found',
    [ERROR_CODES.SETTINGS_NOT_FOUND]: 'System settings not found',
    [ERROR_CODES.GITHUB_API_ERROR]: 'GitHub API request failed',
    [ERROR_CODES.JIRA_API_ERROR]: 'JIRA API request failed',
    [ERROR_CODES.SLACK_API_ERROR]: 'Slack API request failed',
    [ERROR_CODES.JOBKAN_API_ERROR]: 'Jobkan API request failed',
    [ERROR_CODES.LLM_API_ERROR]: 'LLM API request failed',
    [ERROR_CODES.COLLECTION_ALREADY_RUNNING]: 'Collection pipeline is already running for this date range',
    [ERROR_CODES.EXECUTION_NOT_FOUND]: 'Collection execution not found',
    [ERROR_CODES.EVIDENCE_STORAGE_ERROR]: 'Failed to store evidence data',
    [ERROR_CODES.COLLECTION_SOURCE_UNAVAILABLE]: 'Collection source is unavailable',
    [ERROR_CODES.NOTIFICATION_SEND_FAILED]: 'Failed to send notification',
    [ERROR_CODES.NOTIFICATION_DUPLICATE]: 'Notification already sent for this trigger',
    [ERROR_CODES.COMPLIANCE_CALC_FAILED]: 'Compliance calculation failed',
    [ERROR_CODES.VERIFICATION_ALREADY_EXISTS]: 'Verification result already exists for this employee and date',
    [ERROR_CODES.RATE_LIMIT_EXCEEDED]: 'Rate limit exceeded, please try again later',
    [ERROR_CODES.INTERNAL_ERROR]: 'An internal error occurred',
    [ERROR_CODES.SERVICE_UNAVAILABLE]: 'Service temporarily unavailable',
    [ERROR_CODES.DATABASE_ERROR]: 'Database operation failed',
};
//# sourceMappingURL=errors.js.map